import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import { dateFormatters } from '@/utils/date-util'
import styles from './JobTicketsCard.module.css'

interface ItemProps {
  label: string
  value: string
}

function Item({ label, value }: ItemProps) {
  return (
    <div className={styles.item}>
      <div className={styles.itemLabel}>{label}</div>
      <div className={styles.itemValue}>{value}</div>
    </div>
  )
}

export interface JobTicketsCardProps {
  statusMessage?: string | null
  lastUpdated: Date
}

export function JobTicketsCard({
  statusMessage,
  lastUpdated,
}: JobTicketsCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Open ticket</CardTitle>
      </CardHeader>
      <CardContent scroll>
        {statusMessage && <Item label="Reason" value={statusMessage} />}

        <Item
          label="Last updated"
          value={dateFormatters.dateTimeDefault.format(lastUpdated)}
        />
      </CardContent>
    </Card>
  )
}
